/*
 * @Author: Nora Galvin
 * @Date: 2020-08-19 15:54:48
 * @Last Modified by:   Nora
 * @Last Modified time: 2020-08-19 15:54:48
 */
type TypeInteraction = {
  key: string;
  name: string;
  type: string;
  description?: string;
};

/**
 * Action Dropdown template
 * @param interactions the array of interaction
 * @returns string
 */
export default (interactions: Array<TypeInteraction>): string => {
  let template = '';
  interactions.forEach((e) => {
    template += `<div class="tab-item" data-key="${e.key}" data-type="${e.type}"><p>${e.name}</p></div>`;
  });
  return `
    ${template}
    <div class="tab-item-description"><p>This is the place for explaining how interaction trigger animation</p></div>
  `;
};
